export default {
  methods: {
    isNumber(evt) {
      // console.log(evt.keyCode);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode == 43) {
        // checks if the character is a plus sign
        return true;
      } else if (
        // checks if the character is not a number and prevents them from being entered
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
